module.exports = __webpack_public_path__ + "img/11.e7ada560.png";